module.exports = {

	Custom: function(self, item) {

		alert('Running in included .js file inside default list.Vue compontent, proof: '+self.pagination.numPages+' pages in pagination');
	},
	Custom2: function(self, item) {

		alert('Second running custom function, try pagination to page 5');

		self.paginate(5);

	},
}